
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 1.333A4.663 4.663 0 003.333 6c0 2.78 2.947 6.613 4.16 8.073.267.32.754.32 1.02 0C9.72 12.613 12.668 8.78 12.668 6A4.663 4.663 0 008 1.333zm0 6.333a1.667 1.667 0 11.001-3.334 1.667 1.667 0 010 3.334z"}})])
          )
        }
      }
    